module.exports = __webpack_public_path__ + "img/img-chat-begin.1aa4d41c.png";